import { useTranslation } from "react-i18next";
import Data from "./Components/Data";
import { useEffect, useRef, useState } from "react";
import { Sections } from "../../util/types";
import SubSectionsContainer from "./SubSections/SubSectionsContainer";

const IniciativasRegionalesMain: React.FC = () => {
    const { t, i18n } = useTranslation("translation", { keyPrefix: "iniciativas_regionales" });

    const [activeSection, setActiveSection] = useState<Sections>("intro");

    const refreshActiveSection = (section: Sections) => {
        if (activeSection === section) {
            setActiveSection("intro")
            return
        }
        setActiveSection(section);
    }

    const displayContainer = useRef<HTMLDivElement>(null);

    useEffect(() => {
        displayContainer.current?.scrollIntoView({behavior:"smooth"});
    }, [activeSection])

    return (
        <>
            <div className="row text-center mt-5 mb-2 pagetitle">
                <h2>{t('titulo')}</h2>
            </div>
            <div className="row">
                <Data refreshActiveSection={refreshActiveSection} activeSection={activeSection}/>
            </div>
            <div ref={displayContainer}>
                <SubSectionsContainer section={activeSection} />
            </div>
        </>
    )
}

export default IniciativasRegionalesMain